<div class="footer">
	<div class="row">
		<div class="small-12 medium-3 large-3 columns column-left">
			<p class="siteLinks">
				<a [routerLink]="['/faqs']" (click)="goToTop()">FAQs</a><br>
				<a [routerLink]="['/privacy']" (click)="goToTop()">Privacy Policy</a><br>
				<a [routerLink]="['/terms']" (click)="goToTop()">Terms of Use</a><br>
				<a [routerLink]="['/agreement']" (click)="goToTop()">User Service Agreement</a>
			</p>
		</div>
		<div class="small-12 medium-3 large-3 columns column-left">
			<p class="nffLink">
				<a href="https://nff.org.au/wp-content/uploads/2025/01/NFF-Farm-Data-Code-Audit-Report-AWTH-30Jan2025.pdf" target="_blank"><wep-image class="badgeImg" [src]="nffBadge" [alt]="'logo Image'"></wep-image></a>
			</p>
		</div>
		<div class="small-12 medium-6 large-6 columns column-right">
		<wep-button
						class="contactBtn"
						[expanded]="true"
						(click)="goToContact()">
						Contact Us
		</wep-button>
			<br>
			<p>© {{year}} AWTH. All rights reserved.</p>
			<p class="disclaimer">
				The Farm Data Code Certification Trade Mark is owned by the National Farmers’ Federation Limited (NFF), and its use is not an endorsement or a representation by NFF other than that the product was assessed as compliant with the Farm Data Code available at <a href="https://nff.org.au/programs/australian-farm-data-code"> https://nff.org.au/programs/australian-farm-data-code</a>
			</p>
		</div>
	</div>
</div>